import React from "react";
import MaterialUser from "src/old/Components/Organisms/Modules/MaterialUser";

export const MaterialPage = (): JSX.Element => {
	return (
		<>
			<MaterialUser />
		</>
	);
};
